import * as React from "react";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import * as Validator from "../../../../util/validation";
import {AppState} from "../../../store/app_state";

import {Link} from "react-router-dom";
import styled from "styled-components";
import {ConstColor} from "../../../../config/styles_const/styles_const";
import Assets from "../../../assets/img/assets";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import ErrorText from "../../../common/atom/text/error_text";
import Paragraph from "../../../common/atom/text/paragraph";
import ParagraphSup from "../../../common/atom/text/paragraph_sup";
import FormFieldWrapper, {
  PasswordFormFieldWrapper,
  PasswordIconButton,
} from "../../../common/atom/wrapper/form_field_wrapper";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../common/molecular/form_group/form_group_input_connect_rf";
import {AuthFormImg, AuthFormTitle, LoginFormWrapper,} from "../share/auth_share_components";

const validate = (values: any) => {
    const errors: any = {};
    return errors;
};

interface IProps extends InjectedFormProps<FormData, {}> {
}

interface IState {
    showPassword: boolean;
}

export class AuthLoginForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showPassword: false,
        };
    }

    public render(): JSX.Element {
        const {} = this.props;

        const {anyTouched, invalid, handleSubmit, pristine, submitting} =
            this.props;

        return (
            <LoginFormWrapper>
                <AuthFormTitle>ログイン</AuthFormTitle>

                <AuthFormImg src={Assets.login}/>

                <form name="LoginForm" onSubmit={handleSubmit}>
                    <FormFieldWrapper>
                        <Field
                            label="メールアドレス"
                            placeholder="入力してください"
                            name="username"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.email, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <PasswordFormFieldWrapper>
                        <Field
                            label="パスワード"
                            placeholder="入力してください"
                            name="password"
                            component={FormGroupInputConnectRf}
                            type={this.state.showPassword ? "text" : "password"}
                            validate={[Validator.required]}
                            require={true}
                        />
                        <PasswordIconButton
                            type="button"
                            onClick={() => {
                                this.setState((prevState) => ({
                                    showPassword: !prevState.showPassword,
                                }));
                            }}
                        >
                            {this.state.showPassword ? (
                                <i className="fas fa-eye-slash"/>
                            ) : (
                                <i className="fas fa-eye"/>
                            )}
                        </PasswordIconButton>
                    </PasswordFormFieldWrapper>

                    {anyTouched && invalid && (
                        <SubmitErrorTextWrapper>
                            <ErrorText>入力を完了してください</ErrorText>
                        </SubmitErrorTextWrapper>
                    )}
                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="LoginForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}
                        >
                            ログイン
                        </BtnCorporateLarge>
                    </SubmitButtonWrapper>
                </form>

                <PasswordResetParagraphLinkWrapper>
                    <Link to="/passwordreset">
                        <PasswordResetParagraph>
                            パスワード再設定はこちら
                        </PasswordResetParagraph>
                    </Link>
                </PasswordResetParagraphLinkWrapper>

                <ParagraphSup>© Libera Inc.</ParagraphSup>
            </LoginFormWrapper>
        );
    }
}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
    form: "LoginForm",
    validate,
})(connect(mapStateToProps, mapDispatchToProps)(AuthLoginForm));

const PasswordResetParagraphLinkWrapper = styled.div`
    margin: 0 auto 40px auto;
    text-align: center;
`;

const PasswordResetParagraph = styled(Paragraph)`
    display: inline;
    color: ${ConstColor.Corporate};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/login/auth_login_form.tsx